import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "helpers/getEnvVariables";

const {REACT_APP_URL, REACT_APP_WOMPI_URL, REACT_APP_WOMPI_PUBLIC_KEY} =
  getEnvVariables();

// The server's calls carry the customer's token; Wompi's own (tokenizing the
// card and checking the transaction) carry the public key.
const serverHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
});

const wompiHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${REACT_APP_WOMPI_PUBLIC_KEY}`,
});

export const wompiApi = createApi({
  reducerPath: "wompi",
  baseQuery: fetchBaseQuery({baseUrl: REACT_APP_URL}),
  endpoints: (builder) => ({
    getWompiAcceptance: builder.query({
      query: () => ({
        url: "api/v2/wompi/acceptance",
        headers: serverHeaders(),
      }),
      keepUnusedDataFor: 0,
    }),
    tokenizeWompiCard: builder.mutation({
      query: (body: {
        number: string;
        cvc: string;
        exp_month: string;
        exp_year: string;
        card_holder: string;
      }) => ({
        url: `${REACT_APP_WOMPI_URL}/tokens/cards`,
        method: "POST",
        headers: wompiHeaders(),
        body,
      }),
    }),
    payWithWompiCard: builder.mutation({
      query: (body) => ({
        url: "api/v2/wompi/pay-with-card",
        method: "POST",
        headers: serverHeaders(),
        body,
      }),
    }),
    getWompiTransaction: builder.query({
      query: (id: string) => ({
        url: `${REACT_APP_WOMPI_URL}/transactions/${id}`,
        headers: wompiHeaders(),
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetWompiAcceptanceQuery,
  useTokenizeWompiCardMutation,
  usePayWithWompiCardMutation,
  useLazyGetWompiTransactionQuery,
} = wompiApi;
